import { createFileRoute } from '@tanstack/react-router';

import { CallPoolScreen } from '@/features/telephony/components/CallPoolScreen';
import { forbidRoles, requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/app/telephony/')({
  beforeLoad: () => {
    requirePermission('telephony:read');
    // The pool is a psychologist surface: volunteers never receive pool
    // events or hold telephony:claim, so keep them out even if the read
    // permission ever widens.
    forbidRoles(['volunteer']);
  },
  // Clinical surface: psychologists claim and dismiss.
  component: ClinicalCallPoolRoute,
  staticData: { crumb: 'Calls' },
});

function ClinicalCallPoolRoute() {
  return <CallPoolScreen canClaim />;
}
